import Container from "@mui/material/Container";
// import { withStyles } from "@mui/styles";
import { List, ListItem } from "@mui/material";
import LocationInfo from "./LocationInfo";
import { useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import IconButton from "@mui/material/IconButton";
const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
});

function LocationDetails(props) {
  const [take] = useState(100);
  const [skip, setSkip] = useState(0);

  const nextPage = () => {
    setSkip(skip + take);
  };

  const previousPage = () => {
    setSkip(skip - take);
  };

  let locationDetails = props.locationDetails;
  let locationDetailsToShow = locationDetails.slice(skip, skip + take);
  const locationList = <LocationInfo locationId={locationDetailsToShow} />

  return (
    <Container maxWidth="lg">
      {locationDetails ? <List>{locationList}</List> : null}
      {skip !== 0 && (
        <IconButton onClick={previousPage}>
          <ArrowBackIcon />
        </IconButton>
      )}
      {locationDetails.length !== 0 && skip + take < locationDetails.length && (
        <IconButton onClick={nextPage}>
          <ArrowForwardIcon />
        </IconButton>
      )}
    </Container>
  );
}

// export default withStyles(styles, { withTheme: true })(LocationDetails);
export default LocationDetails